import React from "react";

/*
 * Main
 */

export const FileCheckIcon = (): React.ReactElement => {
    return (
        <svg
            aria-hidden="true"
            data-icon="file-check"
            data-prefix="fas"
            focusable="false"
            role="img"
            viewBox="0 0 384 512"
        >
            <path
                d="M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160h136v328c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V24C0 10.745 10.745 0 24 0h200v136c0 13.2 10.8 24 24 24zm65.296 109.732l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L162.12 346.45l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068L70.772 328.2c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
                fill="currentColor"
            />
        </svg>
    );
};
